/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Delete_Folder_Keep_FilesInputs */

const en_dialog_delete_folder_keep_files = /** @type {(inputs: Dialog_Delete_Folder_Keep_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose whether you want to keep the files`)
};

const es_dialog_delete_folder_keep_files = /** @type {(inputs: Dialog_Delete_Folder_Keep_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige si quieres conservar los archivos`)
};

/**
* | output |
* | --- |
* | "Choose whether you want to keep the files" |
*
* @param {Dialog_Delete_Folder_Keep_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_delete_folder_keep_files = /** @type {((inputs?: Dialog_Delete_Folder_Keep_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Delete_Folder_Keep_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_delete_folder_keep_files(inputs)
	return en_dialog_delete_folder_keep_files(inputs)
});